module.exports = __webpack_public_path__ + "static/img/qrcode_search_green.a3abd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode_search_green.png
// module id = 2Oa3
// module chunks = 5